/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from 'react-redux';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { storeContacts } from '@vantiva-sa/homesight_humaui/Store/dataStore';
import { useApiQuery } from './useApiQuery';

const ONE_HOUR_MS = 60 * 60 * 1000;

const useContacts = ({ useruuid }, options = {}) => {
  const { enabled = true } = options;
  const dispatch = useDispatch();

  const trans = useSelector(translator);
  const userApi = useSelector((state) => state.apis.userApi);

  return useApiQuery(
    ['getContacts', useruuid],
    () =>
      new Promise((resolve, reject) => {
        userApi.getContactsByUseruuid(
          useruuid,
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              dispatch(storeContacts({ useruuid, contacts: data?.contacts ?? [] }));
              resolve(data?.contacts ?? []);
            },
            errorCallback: () => {
              reject([]);
            },
          })
        );
      }),
    { enabled: !!useruuid && enabled, staleTime: ONE_HOUR_MS, gcTime: ONE_HOUR_MS }
  );
};

export default useContacts;
